export enum DanceManagerUserRoleEnum {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  TEACHER = 'TEACHER',
  SALES = 'SALES',
  SCANNER = 'SCANNER',
  BARKEEPER = 'BARKEEPER',
}

export const danceManagerUserRoleColors = {
  [DanceManagerUserRoleEnum.ADMIN]: '#e3f2fd',       // Light blue
  [DanceManagerUserRoleEnum.OWNER]: '#fbe9e7',       // Light peach
  [DanceManagerUserRoleEnum.MANAGER]: '#e8f5e9',     // Light green
  [DanceManagerUserRoleEnum.TEACHER]: '#f3e5f5',     // Light purple
  [DanceManagerUserRoleEnum.SALES]: '#fff8e1',       // Light yellow
  [DanceManagerUserRoleEnum.SCANNER]: '#ede7f6',     // Light violet
  [DanceManagerUserRoleEnum.BARKEEPER]: '#f1f8e9'    // Light lime
};

export const danceManagerUserRoleTextColors = {
  [DanceManagerUserRoleEnum.ADMIN]: '#0d47a1',        // Deep blue
  [DanceManagerUserRoleEnum.OWNER]: '#bf360c',        // Deep orange
  [DanceManagerUserRoleEnum.MANAGER]: '#1b5e20',      // Deep green
  [DanceManagerUserRoleEnum.TEACHER]: '#6a1b9a',      // Deep purple
  [DanceManagerUserRoleEnum.SALES]: '#f9a825',        // Amber
  [DanceManagerUserRoleEnum.SCANNER]: '#4527a0',      // Indigo
  [DanceManagerUserRoleEnum.BARKEEPER]: '#558b2f'     // Olive green
};

export const danceManagerUserRoleIcons = {
  [DanceManagerUserRoleEnum.ADMIN]: 'admin_panel_settings', // Same as Fachpool
  [DanceManagerUserRoleEnum.OWNER]: 'account_balance',         // building
  [DanceManagerUserRoleEnum.MANAGER]: 'manage_accounts',    // Gear + person
  [DanceManagerUserRoleEnum.TEACHER]: 'school',             // Teacher/education
  [DanceManagerUserRoleEnum.SALES]: 'point_of_sale',        // POS terminal
  [DanceManagerUserRoleEnum.SCANNER]: 'qr_code_scanner',    // QR scanner
  [DanceManagerUserRoleEnum.BARKEEPER]: 'attach_money'         // Money
};



